exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media (min-width: 1200px) {\n.pre-formatted {\n    -moz-column-count: 2;\n    column-count: 2;\n    -moz-column-gap: 3em;\n    column-gap: 3em;\n}\n}\n@media (min-width: 600px) and (max-width: 1200px) {\n.pre-formatted {\n    -moz-column-count: 1;\n    column-count: 1;\n    -moz-column-gap: 3em;\n    column-gap: 3em;\n}\n}\n@media (max-width: 600px) {\n.pre-formatted {\n    -moz-column-count: 1;\n    column-count: 1;\n    -moz-column-gap: 3em;\n    column-gap: 3em;\n}\n}\n", ""]);

// exports
